/*
 *  ------------------------------
 *   GENERATED CODE - DO NOT EDIT
 *  ------------------------------
 *
 * Generated from:
 *   - src/domain.model
 *   - codegen/templates/domain.ts.mustache
 *   - codegen/gen_domain.ts.ts
 *
 */

import DomainModel from "../DomainModel";


export class Vector3 extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("x", 0);
        this.fields.set("y", 0);
        this.fields.set("z", 0);
    }


    get x(): number {
        return this.get("x") as number;
    }
    set x(value: number) {
        this.set("x", value);
    }
    get y(): number {
        return this.get("y") as number;
    }
    set y(value: number) {
        this.set("y", value);
    }
    get z(): number {
        return this.get("z") as number;
    }
    set z(value: number) {
        this.set("z", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Vector3 {
        const clone = new Vector3(parent ?? this.parent);
        if(deep) {
            clone.x = this.x;
            clone.y = this.y;
            clone.z = this.z;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Vector3
    {
        const result = new Vector3(parent);
        if(!data) {
            return result;
        }

        result.x = data["x"] ?? 0;
        result.y = data["y"] ?? 0;
        result.z = data["z"] ?? 0;
        result.commit();
        return result;
    }

}
